import styled from "styled-components";
import ImgLogo02 from "../assets/img/common/logo_02.png";
import useResize from "../custom_hooks/useResize.tsx";
import INFO from "../setting/INFO";

const Wrapper = styled.div`
  width: 100%;
  height: 153px;
  background: #000000;
  display: flex;
  padding-top: 40px;
  font-size: 14px;
  font-family: SCDream4;
  color: #fff;
  justify-content: space-between;
  line-height: 18px;
  user-select: text;

  @media screen and (max-width: 750px) {
    height: unset;
    padding-bottom: 20px;
    position: static;
  }
`;

const LeftWrpper = styled.div`
  display: inline-block;
  text-align: left;
  margin-left: 14vw;
  font-family: SCDream4;
`;

const RightWrapper = styled.div`
  display: inline-block;
  text-align: left;
  margin-right: 14vw;
  line-height: 23px;
  font-family: SCDream4;
`;

const MobileWrapper = styled.div`
  display: block;
  width: 100%;
  text-align: left;
  font-family: SCDream4;
  padding-left: 8vw;
  padding-right: 8vw;
`;

const MobileTextWrapper = styled.div`
  display: flex;
  font-family: SCDream4;
  justify-content: space-between;
  line-height: 160%;
  font-size: 2.5vw;
`;
const MobileBottomWrapper = styled.div`
  display: block;
  font-family: SCDream4;
  line-height: 160%;
  font-size: 2vw;
  text-align: center;
  margin-top: 20px;
`;
const MobileText = styled.div``;

const Logo = styled.img`
  width: 100px;
  @media screen and (max-width: 750px) {
    width: 20vw;
  }
`;

export default function Footer() {
  const isMobile = useResize() <= 750;

  return (
    <Wrapper>
      {isMobile ? (
        <MobileWrapper>
          <Logo src={ImgLogo02} />
          <MobileTextWrapper>
            <MobileText>
              <br />
              대표 {INFO.CEO_NAME}
              <br />
              사업자등록번호 {INFO.BUSINESS_NO}
            </MobileText>
            <MobileText>
              <br />
              Tel. {INFO.COMPANY_PHONE} <br />
              Fax. {INFO.COMPANY_PAX}
            </MobileText>
          </MobileTextWrapper>
          <MobileBottomWrapper>
            {INFO.COMPANY_ADDRESS}
            <br />
            Copyrightⓒ 2017, {INFO.COMPANY_NAME}. All rights reserved.
          </MobileBottomWrapper>
        </MobileWrapper>
      ) : (
        <>
          <LeftWrpper>
            {INFO.COMPANY_ADDRESS}
            <p />
            Tel. {INFO.COMPANY_PHONE} <br />
            Fax. {INFO.COMPANY_PAX}
            <p />
            <br />
            Copyrightⓒ 2017, {INFO.COMPANY_NAME}. All rights reserved.
          </LeftWrpper>
          <RightWrapper>
            <Logo src={ImgLogo02} />
            <br />
            대표 {INFO.CEO_NAME}
            <br />
            사업자등록번호 {INFO.BUSINESS_NO}
          </RightWrapper>
        </>
      )}
    </Wrapper>
  );
}
